/* Wellinda PDP buybox JS — variant selector + subscription toggle + ATC.
   Single list of variant tiers. The autoship plaque flips the whole list
   between one-time and subscription pricing (via the .sub-active class on
   .product_selector-content) and decides whether the selling plan is added to
   the cart. Requires jQuery; loaded after sitewide.js. */
$(document).ready(function () {
  var $content = $('.product_selector-content');
  if (!$content.length) { return; }

  // Point every CTA scroll-button at the pack selector (#product-selector).
  // sitewide.js binds .scrolling to scroll to .main_product-container; re-bind
  // ours so all CTAs land on the variant selector instead (overrides cta_link).
  var selectorEl = document.getElementById('product-selector');
  if (selectorEl) {
    $('.product_primary-btn.scrolling').off('click').on('click', function (e) {
      e.preventDefault();
      $('html, body').animate({ scrollTop: $(selectorEl).offset().top - 100 }, 500);
    });
  }

  // The mobile gallery arrows are built in sitewide.js with a hardcoded external
  // CDN icon that renders blank for us. Swap in the working local arrow asset
  // (reuse the one the review carousel already loads) so the arrows are visible.
  var galArrowSrc = $('.product_carousel-prev img').attr('src');
  if (galArrowSrc) {
    $('.main_product-image-carousel .slick-prev img, .main_product-image-carousel .slick-next img').attr('src', galArrowSrc);
  }

  function $selected() { return $content.find('.product-selector_block.active').first(); }
  function isSub() { return $content.hasClass('sub-active'); }

  // Plaque "Save X%" reflects the selected variant's real subscription discount.
  function syncPlaqueDiscount() {
    var d = $selected().attr('data-sub-discount');
    if (d !== undefined && d !== '' && d !== '0') {
      $('.pp_var_autoship_title span').text(d);
    }
  }

  // Under-CTA refill-cadence notes follow the selected tier index.
  function syncUnderCta() {
    var idx = $selected().attr('data-index');
    $('.cta-note.changeble').addClass('hided');
    $('.cta-note.changeble[data-id="' + idx + '"]').removeClass('hided');
    $('.product_atc-refills').addClass('hided');
    $('.product_atc-refills[data="' + idx + '"]').removeClass('hided');
  }

  // Swap the one-time / subscription under-CTA note blocks.
  function syncMode() {
    if (isSub()) {
      $('.under_cta_new').removeClass('hided');
      $('.under_cta_new_otp').addClass('hided');
    } else {
      $('.under_cta_new').addClass('hided');
      $('.under_cta_new_otp').removeClass('hided');
    }
  }

  // --- variant selection ---
  $content.on('click', '.product-selector_block', function () {
    $content.find('.product-selector_block').removeClass('active');
    $(this).addClass('active');
    syncPlaqueDiscount();
    syncUnderCta();
  });

  // --- subscription plaque: flip the whole list OTP <-> subscription ---
  $('.pp_var_autoship').on('click', function () {
    $(this).toggleClass('disabled');                       // .disabled == subscription OFF
    $content.toggleClass('sub-active', !$(this).hasClass('disabled'));
    syncMode();
  });

  // initial state
  syncPlaqueDiscount();
  syncUnderCta();
  syncMode();

  // --- add to cart ---
  $('.product-selector_atc').on('click', function () {
    var $btn = $(this);
    if ($btn.hasClass('loading')) { return; }   // guard against double-submit while a request is in flight
    var $b = $selected();
    if (!$b.length) { return; }

    var sub = isSub();
    var vid = $b.attr('data-id');
    var plan = $b.attr('data-selling-plan');
    var title = ($b.find('.product-selector_title').text() || '').trim();

    // Build the cart items. When this tier has Kaching gifts, add them too, each
    // carrying the __kaching_bundles line property so Kaching's Shopify Function
    // zeroes the gifts (works because WE add them, not Kaching's widget).
    var K = window.WL_KACHING;
    var cfg = (K && K.byTitle[title]) || null;
    var items = [];
    if (cfg) {
      var uuid = (window.crypto && crypto.randomUUID) ? crypto.randomUUID() : ('v' + Date.now() + Math.random());
      var bid = Math.random().toString(36).slice(2, 6);
      var main = { id: vid, quantity: 1, properties: { __kaching_bundles: JSON.stringify({ deal: K.deal, main: true, v: uuid, id: bid, bar: cfg.barId }) } };
      if (sub && plan) { main.selling_plan = plan; }
      items.push(main);
      cfg.gifts.forEach(function (g) {
        if (g.subOnly && !sub) { return; } // gift only applies with a subscription
        items.push({ id: g.variantId, quantity: 1, properties: { __kaching_bundles: JSON.stringify({ id: bid, deal: K.deal, v: uuid, gift: g.giftId }) } });
      });
    } else {
      var it = { id: vid, quantity: 1 };
      if (sub && plan) { it.selling_plan = plan; }
      items.push(it);
    }
    // Shopify puts the newest-added lines on top, so send reversed → the main
    // product ends up first in the cart and the free gifts below it.
    items.reverse();

    if (window.klaviyo) {
      var val = parseFloat((sub ? $b.attr('data-price-sub') : $b.attr('data-price-otp')) || 0) / 100;
      klaviyo.push(['track', 'Added to Cart', { $value: val, AddedItemProductName: $b.attr('data-title') || '', AddedItemProductID: vid, AddedItemPrice: val, AddedItemQuantity: 1 }]);
    }

    var goCheckout = $btn.attr('data-checkout') === 'true';
    $btn.addClass('loading').attr('aria-busy', 'true');
    $.ajax({
      type: 'POST', url: '/cart/add.js',
      contentType: 'application/json',
      data: JSON.stringify({ items: items, sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname }),
      dataType: 'json',
      success: function (response) {
        if (goCheckout) { window.location.href = '/checkout'; return; }
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.renderContents === 'function' && response && response.sections) {
          // Clear the stale empty state Dawn stamps on <cart-drawer> when the cart hits 0
          // (deleting the last item then re-adding otherwise keeps showing the empty view).
          drawer.classList.remove('is-empty');
          drawer.renderContents(response);   // refreshes drawer + icon bubble, then opens the drawer
        } else {
          window.location.href = '/cart';    // fallback when cart type is notification / page
        }
      },
      error: function () { alert('Error adding item to the cart.'); },
      // Always clear the loading state — success, error, or redirect.
      complete: function () { $btn.removeClass('loading').removeAttr('aria-busy'); }
    });
  });
});

/* ---- lab-certificate popup (was index_script_53.js) ---- */
function mpLabOpenPopup(){
    var overlay = document.getElementById('mp_lab_overlay');
    if(!overlay){
        return;
    }
    overlay.classList.add('active');
    document.body.style.overflow = 'hidden';
}

function mpLabClosePopup(){
    var overlay = document.getElementById('mp_lab_overlay');
    if(!overlay){
        return;
    }
    overlay.classList.remove('active');
    document.body.style.overflow = '';
}

function mpLabOverlayClick(e){
    var overlay = document.getElementById('mp_lab_overlay');
    if(!overlay){
        return;
    }
    if(e.target === overlay){
        mpLabClosePopup();
    }
}

function mpLabKeydown(e){
    var overlay = document.getElementById('mp_lab_overlay');
    if(!overlay){
        return;
    }
    if(e.key === 'Escape' && overlay.classList.contains('active')){
        mpLabClosePopup();
    }
}

var mpLabBtn = document.querySelector('.mp_lab-btn');
var mpLabOverlay = document.getElementById('mp_lab_overlay');
var mpLabCloseBtn = document.getElementById('mp_lab_close');

if(mpLabBtn){
    mpLabBtn.addEventListener('click', mpLabOpenPopup);
}

if(mpLabCloseBtn){
    mpLabCloseBtn.addEventListener('click', mpLabClosePopup);
}

if(mpLabOverlay){
    mpLabOverlay.addEventListener('click', mpLabOverlayClick);
}

document.addEventListener('keydown', mpLabKeydown);

/* ---- Kaching Bundles integration ----
   Keep OUR product selector as the design. Kaching's app embed loads its
   fetchDeals API, its per-product scripts (productId -> variantId), and the
   Shopify Function that zeroes bundle gifts. We read that config and:
   (1) render the free-gift rows on our tiers (real Kaching gift names);
   (2) our ATC adds the gifts with the __kaching_bundles property (see above).
   Everything is data-driven from Kaching — nothing about the gifts is hardcoded. */
window.WL_KACHING = null;
(function () {
  var $ = window.jQuery || window.$;
  if (!$) { return; }
  function txt(el) { return ((el && el.textContent) || '').trim(); }

  // productId -> {variantId, title, image} from Kaching's embedded product scripts.
  // image = the gift product's own image (editable in the product / Kaching), so
  // each gift shows its own picture instead of one shared hardcoded icon.
  function productMap() {
    var map = {};
    document.querySelectorAll('script.kaching-bundles-product').forEach(function (s) {
      try {
        var j = JSON.parse(s.textContent);
        (Array.isArray(j) ? j : [j]).forEach(function (p) {
          if (p && p.id) { map[p.id] = { variantId: p.selectedVariantId || (p.variants && p.variants[0] && p.variants[0].id), title: p.title, image: p.image }; }
        });
      } catch (e) {}
    });
    return map;
  }

  // bar title -> array of ALL {label, image} rows from Kaching's own (hidden)
  // widget, INCLUDING "Free USA Shipping". These are the perks the merchant
  // configures per bar in the app (label + icon); we render them on our tiers
  // as-is, so nothing (not even shipping) is hardcoded.
  function widgetRows() {
    var wr = {};
    document.querySelectorAll('.kaching-bundles__bar').forEach(function (b) {
      var arr = [];
      b.querySelectorAll('.kaching-bundles__free-gift').forEach(function (row) {
        var label = txt(row.querySelector('.kaching-bundles__free-gift__text')).replace(/^\+\s*free\s*/i, '');
        if (!label) { return; }
        var img = row.querySelector('img');
        arr.push({ label: label, image: img ? img.getAttribute('src') : null });
      });
      wr[txt(b.querySelector('.kaching-bundles__bar-title'))] = arr;
    });
    return wr;
  }

  function renderGifts(byTitle) {
    $('.wl-gift').remove();
    $('.product-selector_block').each(function () {
      var cfg = byTitle[txt(this.querySelector('.product-selector_title'))];
      if (!cfg || !cfg.perks || !cfg.perks.length) { return; }
      var perks = $(this).find('.product-selector_perks');
      cfg.perks.forEach(function (p) {
        perks.append('<div class="product-selector_perk_line wl-gift"><div><img src="' + (p.image || '') + '" /></div><div><p><span class="kaching-bundles__free-gift__text">Free ' + p.label + '</span></p></div></div>');
      });
    });
  }

  function build(deals) {
    if (!deals || !deals.length) { return; }
    var deal = deals[0], pm = productMap(), wr = widgetRows(), byTitle = {};
    (deal.dealBars || []).forEach(function (b) {
      // Cart gifts = product free-gifts (need a variant to add); shipping etc. is
      // display-only. Perks = every widget row for this bar (incl. shipping).
      var gifts = (b.freeGifts || []).map(function (g) {
        var p = pm[g.productId] || {};
        return { variantId: p.variantId, giftId: g.id, subOnly: g.applyOnlyForSubscriptions };
      }).filter(function (g) { return g.variantId; });
      byTitle[b.title] = { barId: b.id, gifts: gifts, perks: wr[b.title] || [] };
    });
    window.WL_KACHING = { deal: deal.nanoId, byTitle: byTitle };
    renderGifts(byTitle);
  }

  function init(attempt) {
    if (!(window.kachingBundlesApi && window.kachingBundlesApi.fetchDeals)) {
      if ((attempt || 0) < 25) { return setTimeout(function () { init((attempt || 0) + 1); }, 300); }
      return;
    }
    Promise.resolve(window.kachingBundlesApi.fetchDeals()).then(build).catch(function () {});
  }
  init(0);
  setTimeout(function () { if (!window.WL_KACHING) { init(0); } }, 2500); // one retry if fetchDeals stalled
})();
